
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import holland from "../../assets/holland.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarHolland({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar holland fordító</title>
                <meta name='description' content="Ingyenes magyar holland fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar holland fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-holland-fordito" />
            </Helmet>
            <h1>Magyar holland fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és holland nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={holland} alt="holland zászló"></img>
                </div>


                <p>Íme néhány fő hasonlóság és különbség a holland és a magyar között:</p>

                <h3>Hasonlóságok</h3>

                <li><b>Fonetikus helyesírás</b>: Mindkét nyelv viszonylag fonetikus helyesírási rendszerrel rendelkezik, ami azt jelenti, hogy a szavakat általában úgy ejtik ki, ahogy írják őket. A kiejtési szabályokban és a sajátos hangzásokban azonban még mindig vannak különbségek a két nyelv között.</li>


                <h3>Különbségek</h3>

                <h4>Szókincs</h4>

                <ul>

                    <li><b>Holland</b>: A holland szókincsre több nyelv is hatással volt, köztük a német, a francia és az angol. Némi hasonlóságot mutat más germán nyelvekkel, például az angollal és a némettel.</li>
                    <li><b>Magyar</b>: A magyar szókincs egyedi, és nincs szoros rokonságban más európai nyelvekkel. Néhány szót kölcsönzött a szomszédos nyelvekből, például a németből, a törökből és a szláv nyelvekből.</li>

                </ul>

                <h4>Nyelvtan</h4>

                <ul>
                    <li><b>Holland</b>: A holland nyelvtan közepesen összetett. Vannak benne főnévi ragozások, igeragozások és nyelvtani nemek (férfi, nőnemű és semleges). Van benne főnévi esetek rendszere is, bár ezek kevésbé hangsúlyosak, mint néhány más nyelvben.</li>
                    <li><b>Magyar</b>: A magyarnak összetett agglutinatív nyelvtana van. A szótövekhez fűződő toldalékrendszert használja, hogy kifejezze az olyan nyelvtani jellemzőket, mint az idő, a mód, a szám és a birtoklás. A magyar nyelvben gazdag főnévi esetrendszer is található a nyelvtani szerepek jelzésére.</li>
                </ul>

                <h4>Ábécé</h4>

                <ul>
                    <li><b>Holland</b>: A holland a germán nyelvekben általánosan elterjedt alany-ige-tárgy (SVO) szórendet követ. A szórend azonban rugalmas lehet az elöljáró- és esethasználat miatt.
                    </li>
                    <li><b>Magyar</b>: A magyar nyelvnek van Alany-Tárgy-Ige (SOV) szórendje, ami eltér a legtöbb európai nyelv tipikus szórendjétől. Az ige általában a mondat végére kerül.</li>
                </ul>

                <h4>Kiejtés</h4>

                <ul>

                    <li><b>Holland</b>: A holland kiejtése regionálisan változhat, de általában sokféle magánhangzóval és mássalhangzóval rendelkezik. Van néhány egyedi hangja is, például a torokhangos "g" és "ch" hangok.</li>
                    <li><b>Magyar</b>: A magyar nyelvnek egyszerű hangrendszere van, következetes kiejtési szabályokkal. Ha megtanulja az egyes betűk és betűkombinációk kiejtését, könnyebbé válik a magyar szavak olvasása és kiejtése.</li>
                </ul>


                <div className="sectionbottom">
                    <Link to="/holland-magyar-fordito">Holland magyar fordító</Link>
                    <img src={holland} alt="holland zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>


            </section>
        </>

    )
}

export default MagyarHolland;